import { httpClient } from '@bcba/client-auth';
import { CreateSignupDto } from './dto/createSignUpDto';
import { ExplorerSignupRequestSerializer } from '@bcba/serializers';

const basePath = '/public/sign-up';

export const postCreateSignup = async (
  payload: CreateSignupDto,
): Promise<ExplorerSignupRequestSerializer> => {
  const { data } = await httpClient.post<ExplorerSignupRequestSerializer>(
    basePath,
    payload,
  );
  return data;
};
